const install = function(Vue) {
   Vue.directive('preventReClick', {
    //禁止重复点击
    inserted (el, binding) {
      el.addEventListener('click', () => {
        if (!el.disabled) {
          el.disabled = true
          setTimeout(() => {
            el.disabled = false
          },binding.value || 1000)
        }
      })
    }
  }),
  Vue.directive('licensePlate', {
    inserted(el, binding, vnode) {
        // 获取原生 input 元素（兼容原生 input 和 UI 组件）
        const inputEl = el.tagName === 'INPUT' ? el : el.querySelector('input');
        if (!inputEl) return; // 找不到 input 元素则退出

        // 格式化函数：仅对英文字母转大写，保留中文和其他字符
        function formatLicense(value) {
            // 仅将小写英文字母转为大写，保留中文和其他所有字符
            return value.replace(/[a-z]/g, char => char.toUpperCase());
        }

        // 获取 Vue 绑定的 v-model 信息
        const model = vnode.data.model;
        if (!model) return;

        // 使用防抖处理，避免干扰输入法
        let timeoutId = null;
        const updateModelDebounced = (value) => {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(() => {
                const formattedValue = formatLicense(value);
                if (formattedValue !== model.value) {
                    model.callback(formattedValue);
                    // 只在值确实变化时更新输入框
                    if (inputEl.value !== formattedValue) {
                        const cursorPos = inputEl.selectionStart;
                        inputEl.value = formattedValue;
                        // 恢复光标位置
                        inputEl.setSelectionRange(cursorPos, cursorPos);
                    }
                }
            }, 100);
        };

        // 输入事件处理（使用 blur 事件为主，input 事件为辅）
        const handleInput = (e) => {
            // 不对中文输入法过程中的内容进行处理
            if (e.isComposing || e.keyCode === 229) {
                return;
            }
            updateModelDebounced(inputEl.value);
        };

        // 失去焦点时确保最终格式化
        const handleBlur = () => {
            const formattedValue = formatLicense(inputEl.value);
            if (formattedValue !== model.value) {
                model.callback(formattedValue);
                inputEl.value = formattedValue;
            }
        };

        // 粘贴事件处理
        const handlePaste = (e) => {
            e.preventDefault();
            const text = e.clipboardData.getData('text');
            const formattedValue = formatLicense(text);
            // 在光标位置插入粘贴的内容
            const startPos = inputEl.selectionStart;
            const endPos = inputEl.selectionEnd;
            const currentValue = inputEl.value;
            const newValue = currentValue.substring(0, startPos) + 
                             formattedValue + 
                             currentValue.substring(endPos);
            
            inputEl.value = newValue;
            model.callback(newValue);
            // 设置光标位置
            inputEl.setSelectionRange(startPos + formattedValue.length, startPos + formattedValue.length);
        };

        // 绑定事件到原生 input 元素
        inputEl.addEventListener('input', handleInput);
        inputEl.addEventListener('blur', handleBlur);
        inputEl.addEventListener('paste', handlePaste);
        inputEl.addEventListener('compositionstart', (e) => {
            // 中文输入法开始时不处理
        });
        inputEl.addEventListener('compositionend', (e) => {
            // 中文输入法结束后统一处理
            updateModelDebounced(inputEl.value);
        });

        // 存储事件用于解绑
        inputEl._licenseHandlers = { handleInput, handleBlur, handlePaste };
    },
    unbind(el) {
        // 解绑事件，避免内存泄漏
        const inputEl = el.tagName === 'INPUT' ? el : el.querySelector('input');
        if (inputEl && inputEl._licenseHandlers) {
            inputEl.removeEventListener('input', inputEl._licenseHandlers.handleInput);
            inputEl.removeEventListener('blur', inputEl._licenseHandlers.handleBlur);
            inputEl.removeEventListener('paste', inputEl._licenseHandlers.handlePaste);
            delete inputEl._licenseHandlers;
        }
    }
    });
}
export default install
